import { HorizontalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BaseNotification: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => (
    <HorizontalContainer
        className={`${className} ${styles.baseNotificationContainer}`}
        testId={testId}>
        {children}
    </HorizontalContainer>
);

export default BaseNotification;
